"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const Duration_1 = __importDefault(require("./Duration"));
const axios_1 = __importDefault(require("axios"));
function passenger(props) {
    const [paxCount, setPaxCount] = react_1.default.useState(null);
    const [paxData, setPaxData] = react_1.default.useState(null);
    const [errorModalOpen, setErrorModalOpen] = react_1.default.useState(false);
    const [bookedModalOpen, setBookedModalOpen] = react_1.default.useState(false);
    const [firstRender, setFirstRender] = react_1.default.useState(true);
    const handlePaxCountChange = (paxCount) => {
        console.log("handlePaxCountChange", paxCount);
        if (paxCount === null) {
            setPaxCount(null);
        }
        else {
            const correctedPaxCount = Math.max(Number(1), Math.min(Number(paxData === null || paxData === void 0 ? void 0 : paxData.capacity), Number(paxCount)));
            console.log("correctedPaxCount:", correctedPaxCount);
            setPaxCount(correctedPaxCount);
        }
    };
    (0, react_1.useEffect)(() => {
        console.log("useEffect pax");
        getPaxData();
    }, [props]);
    const getPaxData = () => {
        console;
        const baseUrl = "/api/widget/pax/" + props.uuid;
        const params = new URLSearchParams();
        params.append("selectedDate", props.selectedDate.toString());
        axios_1.default
            .get(baseUrl, {
            params: params,
        })
            .then((response) => {
            console.log(response.data);
            setPaxData(response.data);
            if (firstRender) {
                setTimeout(() => {
                    var _a;
                    (_a = document.getElementById(props.parentElementId)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
                    setFirstRender(false);
                });
            }
        })
            .catch((error) => {
            console.log(error);
        });
    };
    return (react_1.default.createElement("div", { id: "pax" },
        react_1.default.createElement(material_1.Grid, { container: true, spacing: 4 },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(material_1.Typography, { variant: "h4" }, "Number of Guests"),
                    react_1.default.createElement(material_1.Typography, { variant: "body1" },
                        "Max (", paxData === null || paxData === void 0 ? void 0 :
                        paxData.capacity.toString(),
                        ")")),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(material_1.Input, { type: "number", value: (paxCount && paxCount.toString()) || "", slotProps: {
                            input: {
                                min: 1,
                                max: paxData === null || paxData === void 0 ? void 0 : paxData.capacity.toString(),
                                step: 1,
                            },
                        }, onChange: (e) => {
                            if (e.target.value) {
                                handlePaxCountChange(parseInt(e.target.value));
                            }
                            else {
                                handlePaxCountChange(null);
                            }
                        }, fullWidth: true }))),
            paxCount && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(Duration_1.default, { uuid: props.uuid, brandId: props.brandId, selectedDate: props.selectedDate, paxCount: paxCount, parentElementId: "pax" }))))));
}
exports.default = passenger;
